import React, { Component } from "react";
import { connect } from "react-redux";
import Table, { tableActions } from '@mawesi-sas/mws_react_component_table';
import { showHideModalCreatePresupuesto } from "../actions";
import { toast } from "react-toastify";

const { mswTable_mostrarDatos } = tableActions;

class Presupuestos extends Component {
  // componentDidMount() {
  //   let presupuestos = [];
  //   if (this.props.modalCreate.getIn("data.tables.presupuestos".split("."))) {
  //     presupuestos = this.props.modalCreate
  //       .getIn("data.tables.presupuestos.data".split("."))
  //       .valueSeq()
  //       .toJS();
  //   }

  //   presupuestos = presupuestos.concat(
  //     this.props.modalCreate
  //       .getIn(`data.presupuestos`.split("."))
  //       .toJS()
  //       .map(x => {
  //         x._enabled = true;
  //         return x;
  //       })
  //   );

  //   this.props.mswTable_mostrarDatos(
  //     "cencos",
  //     "modalCreate.data.tables.presupuestos",
  //     presupuestos,
  //     1,
  //     presupuestos.length
  //   );
  // }

  showHideModalCreatePresupuesto = (show, id) => {
    if (this.props.elementos.filter(x => x === "AXkmoTuy").count()) {
      this.props.showHideModalCreatePresupuesto(show, id);
    } else {
      toast.error("Su usuario no tiene permitido ejecutar esta acción", {
        bodyClassName: "toastify-content toastify-danger"
      });
    }
  };

  render() {
    return (
      <Table
        reducer="cencos"
        table={`modalCreate.data.tables.presupuestos`}
        columns={[
          {
            ID: 1,
            CAPTION: "Periodo",
            TYPE: "custom",
            WIDTH: 80,
            RENDER_ROW: reg => {
              return (
                <span
                  style={{ color: "#4f9fcf", cursor: "pointer" }}
                  onClick={e =>
                    this.showHideModalCreatePresupuesto(
                      true,
                      reg.get("id3n71f13r")
                    )
                  }
                >
                  {reg.getIn("periodo".split("."))}
                </span>
              );
            }
          },
          {
            ID: 2,
            CAPTION: "Valor total",
            VALUE: "valor_total",
            TYPE: "number",
            FORMAT: "$0,0.00"
          },
          {
            ID: 3,
            CAPTION: "Valor disponible",
            VALUE: "valor_disponible",
            TYPE: "number",
            FORMAT: "$0,0.00"
          }
        ]}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    modalCreate: state.cencos.get("modalCreate"),
    elementos: state.layout.get("elementos")
  };
}

const mapDispatchToProps = {
  mswTable_mostrarDatos,
  showHideModalCreatePresupuesto
};

export default connect(mapStateToProps, mapDispatchToProps)(Presupuestos);
